<template>
    <div id="systemmodule">
        <HrrBreadcrumb PMname="信息管理" CMname="媒体信息管理" />
        <HrrMainLayout>
            <template slot="searh">
                <el-form :inline="true" :model="searchform">
                    <el-form-item label="站点名称：">
                        <el-select v-model="SiteId2" multiple placeholder="请选择">
                            <el-option v-for="item in siteidData" :key="item.SiteId" :label="item.SiteName" :value="item.SiteId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-input v-model="keyword" placeholder="关键字">
                            <el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
                                <el-option label="媒体编号" value="lightBoxCode"></el-option>
                                <el-option label="设备编号" value="deviceNickCode"></el-option>
                                <el-option label="媒体名称" value="lightBoxName"></el-option>
                                <el-option label="媒体描述" value="lightBoxDesc"></el-option>
                                <el-option label="媒体地址" value="lightBoxAddress"></el-option>
                            </el-select>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="设备状态：">
                        <el-select v-model="deviceStatus" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="在线" value="1"></el-option>
                            <el-option label="离线" value="0"></el-option>
                            <el-option label="异常" value="2"></el-option>
                            <el-option label="未绑定" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </el-form>
            </template>
            <template slot="buttons">
                <el-button-group>
                    <el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick" v-if="isHadFun('Add')">新增</el-button>
                    <el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick" v-if="isHadFun('Update')">编辑</el-button>
                    <el-button type="primary" icon="el-icon-delete" size="small" @click="delclick" v-if="isHadFun('Delete')">删除</el-button>
                    <el-button type="primary" icon="fa fa-check-square-o" size="small" v-if="false">审核</el-button>
                    <el-button type="info" icon="fa fa-undo" size="small" @click="returnMForm()" v-if="isShowReturn">返 回</el-button>
                </el-button-group>
            </template>
            <template slot="table">
                <el-table :data="tableData" ref="Opentable" @cell-click="cellclick" @selection-change="selectionchange" border stripe style="width: 100%" v-loading="loading" :cell-style="cellStyle" @sort-change="sortchange">
                    <el-table-column type="selection" width="55" fixed="left">
                    </el-table-column>
                    <el-table-column prop="siteName" label="站点" width="170" fixed="left" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="lightBoxCode" label="媒体编号" width="130" fixed="left" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="lightBoxAddress" label="媒体地址" width="160">
                    </el-table-column>
                    <el-table-column prop="initI" label="100%亮度电流A-B-C(安)" width="200" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="lastPowerWaste" label="当前电流A-B-C(安)" width="170" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="lastLight" label="亮度(%)" width="100" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="lastWorkedTimeFormat" label="工作时长" width="130" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="lastACStatus" label="AC通断电状态" width="140" sortable="custom">
                        <template slot-scope="scope">
                            <span v-if="scope.row.lastACStatus==0">关断</span>
                            <span v-if="scope.row.lastACStatus==1">导通</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="deviceNickCode" label="设备编号" width="140">
                    </el-table-column>
                    <el-table-column prop="lightBoxName" label="媒体名称" width="140">
                    </el-table-column>
                    <el-table-column prop="lightBoxDesc" label="媒体描述" width="180">
                    </el-table-column>
                    <el-table-column prop="creationDate" label="创建时间" width="180" sortable="custom">
                    </el-table-column>
                    <el-table-column prop="creationBy" label="创建人" width="80">
                    </el-table-column>
                    <el-table-column label="状态" width="70" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="scope.row.status?'success':'danger'" disable-transitions>{{scope.row.status?'启用':'禁用'}}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column label="设备状态" width="78" fixed="right">
                        <template slot-scope="scope">
                            <i :class="'fa fa-2x '+linestatus(scope.row)" style="margin-left:12px;margin-top:4px;"></i>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click.stop="Rowview(scope.row)" type="text" size="small" v-if="isHadFun('See')">查看</el-button>
                            <el-button @click.stop="RowEdit(scope.row)" type="text" size="small" v-if="isHadFun('Update')">编辑</el-button>
                            <el-button @click.stop="Rowdelete(scope.row)" type="text" size="small" v-if="isHadFun('Delete')">删除</el-button>
                            <el-button @click.stop="RowSend(scope.row)" type="text" size="small" v-if="isShowSend(scope.row)">发送指令</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
            <template slot="Pagination">
                <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchform.pageNum" :page-sizes="[5, 10, 15]" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </template>
        </HrrMainLayout>
        <el-dialog :title="'媒体编号：'+Devicedetail.lightBoxCode" v-model="dialogVisible" :visible.sync="dialogVisible" class="el-dialog-resume">
            <el-card>
                <template slot-scope="scope">
                    <el-form label-width="120px" size="mini" inline>
                        <el-form-item label="设备编号：">
                            {{Devicedetail.deviceNickCode}}
                        </el-form-item>
                        <el-form-item label="电流：">
                            {{Devicedetail.lastPowerWaste}}
                        </el-form-item>
                        <el-form-item label="亮度：">
                            {{Devicedetail.lastLight}}
                        </el-form-item>
                        <el-form-item label="工作时长：">
                            {{Devicedetail.lastWorkedTimeFormat}}
                        </el-form-item>
                        <el-form-item label="AC通断电状态：">
                            {{Devicedetail.lastACStatus==1?'导通':'关断'}}
                        </el-form-item>
                        <el-form-item label="状态：">
                            <i :class="'fa fa-2x '+linestatus(Devicedetail)" style="margin-left:12px;margin-top:4px;"></i>
                        </el-form-item>
                        <el-form-item label=" ">
                            <el-button type="info" @click="RowLineChart(Devicedetail)">查看数据折线图</el-button>
                        </el-form-item>
                    </el-form>
                </template>
            </el-card>
            <br />
            <el-card>
                <template slot-scope="scope">
                    <el-form label-width="120px" size="mini" inline>
                        <el-form-item :label="item.attrType+'：'" v-for="item in  DeviceConfig">
                            {{item.attrValue}}
                        </el-form-item>
                    </el-form>
                </template>
            </el-card>
        </el-dialog>
    </div>
</template>
<script>
export default {
    name: 'lightbox_info',
    data() {
        return {
            searchform: {
                pageNum: 1,
                pageSize: 10,
                siteId: "",
                lightBoxCode: "",
                deviceNickCode: "",
                lightBoxName: "",
                lightBoxDesc: "",
                lightBoxAddress: "",
                isOnline: "",
                bindType: "",
                lastIsError: "",
                ColumnName: "",
                OrderType: ""
            },
            siteidData: [],
            tableData: [],
            planIdData: [],
            Devicedetail: {},
            DeviceConfig: {},
            total: 0,
            loading: true,
            selectionRows: [],
            selectfield: "lightBoxCode",
            SiteId2: [],
            keyword: "",
            isFormLightbox: true,
            isShowReturn: false,
            dialogVisible: false,
            deviceStatus: "",
            returnPath: ""
        }
    },
    methods: {
        onSubmit() {
            this.searchform.lightBoxCode = "";
            this.searchform.lightBoxName = "";
            this.searchform.lightBoxDesc = "";
            this.searchform.lightBoxAddress = "";
            this.searchform.pageNum = 1;
            this.searchform[this.selectfield] = this.keyword.trim();
            this.initData();
            this.$route.meta.searchform = this.searchform;
        },
        handleSizeChange(val) {
            this.searchform.pageSize = val;
            this.initData();
        },
        handleCurrentChange(val) {
            this.searchform.pageNum = val;
            this.initData();
            this.$route.meta.searchform = this.searchform;
        },
        Rowview(val) {
            this.$route.meta.row = val;
            this.$route.meta.parentReturnPath = this.returnPath;
            this.$router.push({ path: '/lightbox/info/view/' + val.lightBoxId });
        },
        RowEdit(val) {
            this.$route.meta.row = val;
            this.$route.meta.parentReturnPath = this.returnPath;
            this.$router.push({ path: '/lightbox/info/edit/' + val.lightBoxId });
        },
        Rowdelete(val) {
            this.$confirm("确定要删除 '" + val.lightBoxCode + "' 此记录么？", "删除提示", { type: "warning" })
                .then(() => {
                    var Vuethis = this;
                    this.$hrraxios({
                            method: "delete",
                            url: this.$api.lightbox.DelLightbox + "/" + val.lightBoxId
                        })
                        .then((response) => {
                            var redata = response.data;
                            if (redata.Success == true) {
                                Vuethis.$message({ message: "删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                Vuethis.$message({ message: redata.Prompt, type: "error" });
                            }
                        })
                }).catch((error) => {
                    console.log(error);
                });
        },
        returnMForm() {
            this.$router.push({ path: this.returnPath });
        },
        isShowSend(val) {
            return this.isHadFun('SendOrder') && val.deviceCode != "";
        },
        linestatus(row) {
            if (row.deviceCode == "") {
                return " device-offline fa-ban";
            }
            if (row.lastIsError == 1) {
                return " fa-exclamation-circle device-error";
            }
            if (row.isOnline == null) {
                return " fa-wifi device-never";
            }
            if (row.isOnline == 1) {
                return " fa-wifi device-online";
            }
            if (row.isOnline == 0) {
                return " fa-wifi device-offline";
            }
        },
        sortchange(sortinfo) {
            this.searchform.ColumnName = sortinfo.order == null ? null : (sortinfo.prop == "lastWorkedTimeFormat" ? "lastWorkedTime" : sortinfo.prop);
            this.searchform.OrderType = sortinfo.order;
            this.initData();
        },
        cellStyle(row, column, rowIndex, columnIndex) {
            if (row.column.label === "设备数") {
                return 'font-weight: bolder;color:#ff9c70;text-align:center'
            }
        },
        RowDevice(val) {
            if (val.deviceCode != "") {
                this.dialogVisible = true;
                this.Devicedetail = val;
                this.initConfig(val.deviceCode);
            } else {
                this.$message({ message: "媒体未绑定设备", type: "warning" });
            }

        },
        RowSend(val) {
            this.$route.meta.parentReturnPath = this.returnPath;
            this.$router.push({ path: '/device/infoforsend' + "/" + val.deviceCode });
        },
        RowLineChart(val) {
            this.$router.push({ path: '/site/customreport' + "/" + val.deviceCode });
        },
        Addclick() {
            this.$router.push({ path: '/lightbox/info/add/', });
        },
        handleClick(tab, event) {
            console.log(tab, event);
        },
        pubclick() {
            if (this.selectionRows.length == 0) {
                this.$message({ message: "请先选择一行在操作", type: "warning" });
                return;
            }
        },
        editclick() {
            if (this.selectionRows.length == 0) {
                this.$message({ message: "请先选择一行在操作", type: "warning" });
                return;
            }
            if (this.selectionRows.length > 1) {
                this.$message({ message: "只能操作一行数据", type: "warning" });
                return;
            }
            this.$route.meta.row = this.selectionRows[0];
            this.$router.push({ path: '/lightbox/info/edit/' + this.selectionRows[0].lightBoxId });
        },
        delclick() {
            if (this.selectionRows.length < 1) {
                this.$message({ message: "请先选择一行在删除", type: "warning" });
                return;
            }
            this.$confirm("确定要删除这些记录么？", { type: "warning" })
                .then(() => {
                    var loading = this.$loading({
                        lock: true,
                        text: '删除中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    var Vuethis = this;
                    var PostfunArr = [];
                    this.selectionRows.forEach(myrow => {
                        var postRe = this.$hrraxios({
                            method: "delete",
                            url: this.$api.lightbox.DelLightbox + "/" + myrow.lightBoxId
                        })
                        PostfunArr.push(postRe);
                    });
                    this.$axios.all(PostfunArr)
                        .then(this.$axios.spread(function() {
                            loading.close();
                            //console.log(arguments);
                            var isalldel = true;
                            for (var i = 0; i < arguments.length; i++) {
                                if (arguments[i].data.Success == false) {
                                    isalldel = false;
                                }
                            }
                            if (isalldel == true) {
                                Vuethis.$message({ message: "全部删除成功！", type: "success" });
                                Vuethis.initData();
                            } else {
                                //有删除失败的未处理
                            }
                        }));
                })
                .catch((error) => {

                });
        },
        cellclick(row, column, cell, event) {
            if (column.label == "设备状态") {
                this.RowDevice(row);
            }
            this.$refs.Opentable.toggleRowSelection(row);
        },
        selectionchange(selection) {
            this.selectionRows = selection;
        },
        initData() {
            var Vuethis = this;
            this.loading = true;
            if (this.SiteId2.length > 0) {
                this.searchform.siteId = this.SiteId2.join(",");
            } else {
                this.searchform.siteId = "";
            }
            this.searchform.isOnline = (this.deviceStatus != "" && this.deviceStatus < 2) ? this.deviceStatus : "";
            this.searchform.bindType = (this.deviceStatus == 3) ? "未绑定" : "";
            this.searchform.lastIsError = (this.deviceStatus == 2) ? 1 : "";
            this.$hrraxios.get(this.$api.lightbox.getLightboxnew, { params: this.searchform })
                .then(function(response) {
                    Vuethis.loading = false;
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.tableData = data.Data.List;
                        Vuethis.total = data.Data.Total;
                        Vuethis.tableData.forEach(item => {
                            if (item.lastWorkedTime != null && item.lastWorkedTime != "") {
                                let WkArr = item.lastWorkedTime.toString().split(".");
                                let min = parseInt((item.lastWorkedTime - WkArr[0]) * 60);
                                item.lastWorkedTimeFormat = WkArr[0] + "小时" + min + "分";
                            } else {
                                item.lastWorkedTimeFormat = null;
                            }
                        });
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    Vuethis.loading = false;
                    console.log(error);
                });
        },
        initParamsData() {
            var Vuethis = this;
            this.$hrraxios.get(this.$api.site.downlist)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.siteidData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        analysisLight(cmd) {
            let cmdArr = cmd.split(",");
            let re = "";
            for (let i = 0; i < cmdArr.length; i++) {
                let hour = cmdArr[i].substring(2, 4);
                let min = cmdArr[i].substring(4, 6);
                let l = cmdArr[i].substring(6, 9);
                re += "[亮度在" + hour + "时" + min + "分" + "亮度调整为" + parseInt(l) + "%]";
            }
            return re;
        },
        initConfig(deviceCode) {
            var Vuethis = this;
            this.$hrraxios.get(this.$api.device.config + "/" + deviceCode)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.DeviceConfig = data.Data;
                        Vuethis.DeviceConfig.forEach((item, index) => {
                            if (item.attrType == "light") {
                                item.attrType = "调光";
                                item.attrValue = Vuethis.analysisLight(item.attrValue);
                            }
                            if (item.attrType == "start") {
                                item.attrType = "启动周期";
                                item.attrValue = "每半小时指令获取" + item.attrValue.substring(2, 4) + "次";
                            }
                            if (item.attrType == "update") {
                                item.attrType = "更新";
                                let uarr = item.attrValue.split(";");
                                item.attrValue = uarr[4] + ";" + uarr[5];
                            }
                            if (item.attrType == "urgentstop") {
                                item.attrType = "急停";
                                item.attrValue = item.attrValue == "031" ? "解除急停" : "急停";
                            }
                            if (item.attrType == "uploadcycle") {
                                item.attrType = "数据上传周期";
                                item.attrValue = "每半小时数据上传" + item.attrValue.substring(2, 4) + "次";
                            }
                            if (item.attrType == "custom") {
                                item.attrType = "自定义指令";
                            }
                            if (item.attrType == "open") {
                                item.attrType = "开灯";
                                item.attrValue += "(弃用)";
                            }
                            if (item.attrType == "close") {
                                item.attrType = "关灯";
                                item.attrValue += "(弃用)";
                            }
                            item.attrValue += "(最后操作时间：" + (item.lastUpdateDate == null ? item.creationDate : item.lastUpdateDate) + ")";
                        });
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    },
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        to.meta.row = from.meta.row;
        to.meta.parentReturnPath = from.meta.parentReturnPath;
        next();
    },
    beforeRouteEnter(to, from, next) {
        if (from.path.indexOf("lightbox/info") == -1 && from.path.indexOf("infoforsend") == -1) {
            delete to.meta.searchform;
            delete from.meta.searchform;
        }
        next(vm => {
            if (from.path.indexOf("lightbox/info") == -1 && from.path.indexOf("infoforsend") == -1) {
                vm.returnPath = from.path;
            } else {
                vm.returnPath = from.meta.parentReturnPath;
            }
        })
    },
    created() {
        //功能管理
        if (this.$route.meta.searchform != undefined) {
            this.searchform = this.$route.meta.searchform;
            this.$common.FindhadValue(["lightBoxCode", "deviceNickCode", "lightBoxName", "lightBoxDesc", "lightBoxAddress"], this.searchform, this);
            if (this.searchform.siteId.length > 0) {
                let arr = this.searchform.siteId.split(",");
                this.SiteId2 = [];
                for (let i = 0; i < arr.length; i++) {
                    this.SiteId2.push(parseInt(arr[i]));
                }
            }
            this.deviceStatus=this.searchform.isOnline!=""?this.searchform.isOnline:this.searchform.bindType!=""?"3":this.searchform.lastIsError!=""?"2":"";
        }
        this.$common.getFunListByMCode(this, "LightBoxInfo", () => {
            if (this.$route.fullPath.indexOf("infoforsite") > 0) {
                this.isShowReturn = true;
                this.SiteId2 = [parseInt(this.$route.params.id)];
                if (this.$route.params.lbcode) {
                    this.searchform.lightBoxCode = this.$route.params.lbcode;
                    this.keyword = this.$route.params.lbcode;
                }
            } else {
                this.isShowReturn = false;
            }
            this.initData();
            this.initParamsData();
        });
    }
};
</script>
<style>
.input-with-select {
    width: 110px;
}

.educard label {
    color: #99a9bf;
}

.educard {
    margin-bottom: 10px;
}

.utable .el-button,
.utable .el-button+.el-button {
    margin-right: 10px;
    margin-left: 0;
}

#lightForm .el-select {
    width: 100px;
}
</style>